import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleApi } from '@classes/role/role';
import { environment } from '@environments/environment';
import { AuthService } from '@services/auth/auth.service';
import { DataService } from '@services/data/data.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RolesService {
  application: any;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  getRoleUserApp(): void {
    const appsUser = this.authService.getDecodedToken()?.application;
    const app = this.router.url.split('/')[1];
    const appUserRoute = appsUser?.find(apps => apps?.applicationName?.toLowerCase() === app?.toLowerCase());
    this.dataService.userAppSelected.next(appUserRoute);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getAllRole(): Observable<RoleApi[]> {
    return this.http.get<RoleApi[]>(`${environment.apiUrl}/roles`, {
      headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` }
    })
  }
}
